import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0282',
    ecrans: ['00-2']
});
